<!-- <ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" [color]="'#C20047'"></ng-progress> -->

<!-- <div class="pageTitle ">
   {{title}}
  <i class="material-icons pullfloat-right" (click)="closeSetting()"  title="close">close</i>
</div> -->
<!-- <div class="component-wrapper" (clickOutside)="onClickedOutside($event)"> -->
<div class="component-wrapper" (click)="onClickShopCart($event)">
    <div style="width: 270px;">
        <!-- <button class="download-excel small-button" (click)="downloadExcel()">DOWNLOAD TO EXCEL</button>
  <h2 class="shoppingcart-section">
    <span class="section-name">All Carts</span>
    <span class="sort-icon" (click)="sortCartList()">
      A to Z
      <i class="fas fa-long-arrow-alt-up"></i>
      <i class="fas fa-long-arrow-alt-down"></i>
    </span>
  </h2>
  <hr class="shoppingcart-separator"> -->
        <div class="searchInputGroup searchInputGroup-margin">
            <div class="searchIcon">
                <!-- <i class="fas fa-search fa-lg"></i> -->
                <img src="../images/new_ui/filter.png">
            </div>
            <input #searchInput class="searchInput searchInputGroup-small" type="text" (keyup)="searchShoppingCart(searchInput.value)" placeholder="Filter" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Filter'">

            <!-- <img src="../images/new_ui/addIcon.png" class="add-cart-btn" (click)="open(changeCartNameContainer, $event)"> -->
            <ng-container *ngIf="currentUserModel?.source!='SAP'">
                <div class="basic-icon add-icon add-icon-position" (click)="open(changeCartNameContainer, $event)"></div>
            </ng-container>
        </div>

        <table class="table table-hover shopping-cart white">
            <tbody>

                <ng-container *ngIf="currentUserModel?.source!='SAP'">

                    <tr placement="bottom" class="name-edit watch-list-container">
                        <td class="col-sm-10 col-md-10" style="padding-bottom: 5px;" (click)="accessWatchList();closeSetting();">
                            <div class="cart-name">
                                <span style="padding-left: 20px;">
                Watch List
              </span>
                            </div>
                            <div class="cart-quantity ">Total Items: {{watchListItems?.length?watchListItems?.length:0}}</div>
                        </td>
                        <td class="col-sm-2 col-md-2" style="padding-right: 15px;">
                            <span class="navview" (click)="accessWatchList();closeSetting();">
              View
            </span>
                        </td>
                    </tr>

                </ng-container>


                <!-- <tr [class.cart-selected]="cartId == shoppingcart.cartId" placement="bottom" [ngbTooltip]="'CHANGE ACTIVE CART'" class="name-edit" *ngFor="let shoppingcart of shoppingCarts"> -->
                <tr [class.cart-selected]="cartId == shoppingcart.cartId" placement="bottom" class="name-edit" *ngFor="let shoppingcart of fliterdShoppingCarts">
                    <!-- <td style="vertical-align: middle;">
          <div class="cartname-icon" title="Edit Shopping Cart" style="margin-bottom: 10px" (click)="editCartDetail(shoppingcart.cartId, shoppingcart.cartName)">
            <i class="fas fa-check-square"></i>
            &#9745;
          </div>
          <div class="cartname-icon" title="Remove Shopping Cart" *ngIf="shoppingCarts.length!=1" (click)="deleteCart(shoppingcart.cartId, shoppingcart.cartName)">
            <i class="fas fa-trash-alt"></i>
          </div>
        </td> -->
                    <!--setActiveCart(shoppingcart?.cartId);-->
                    <td class="col-sm-10 col-md-10" (click)="selectCartNoRedirect(shoppingcart);closeSetting();">
                        <!-- <div class="cart-name" *ngIf="editCart != shoppingcart.cartName">
            <span class="name-edit" title="Edit Cart Name" (click)="editCartName(shoppingcart.cartName)">
              <i class="fas fa-1x fa-pencil-alt"></i>
            </span>           
            {{shoppingcart?.cartName}} 
            <span *ngIf="shoppingcart?.status && shoppingcart?.status == 3" style="color: red">
              <i class="fas fa-1x fa-globe"></i>
            </span>
          </div> -->

                        <!-- <div class="cart-name" title="Edit Shopping Cart" (click)="editCartDetail(shoppingcart.cartId, shoppingcart.cartName)">
              <span class="name-edit" >
                <i class="fas fa-1x fa-pencil-alt"></i>
                
                {{shoppingcart?.cartName}}
              </span>
            </div> -->

                        <div class="cart-name">
                            <span style="padding-left: 20px;">
                <!-- <span *ngIf="cartId == shoppingcart.cartId">&#9745;</span> -->
                            <!-- <span *ngIf="cartId != shoppingcart.cartId">&#9744;</span> -->
                            {{shoppingcart?.cartName}}
                            <span class="navshare" *ngIf="shoppingcart.status && shoppingcart.status == 3" style="color: rgb(202, 24, 69);">
                  <!-- <i class="fas fa-1x fa-globe"></i> -->
                  <span class="share-button"></span>
                            </span>
                            </span>
                        </div>

                        <div class="cart-name" *ngIf="editCart == shoppingcart.cartName">
                            <input #editCartName class="edit-input edit{{shoppingcart.cartId}}" type="text" [value]="editCart" (blur)="confirmCartNameValue(editCartName.value, shoppingcart)" (keyup.enter)="confirmCartNameValue(editCartName.value, shoppingcart)">
                        </div>
                        <div class="cart-quantity ">Total Items: {{shoppingcart?.totalQuantity}}</div>
                        <div class="cart-subtotal">Subtotal: {{shoppingcart?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                        </div>
                    </td>

                    <td class="col-sm-2 col-md-2" style="padding-right: 15px;">
                        <span class="navview" (click)="selectCart(shoppingcart);closeSetting();">
              View Cart
            </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- <div class="reveal add-cart-size" id="changeCartNameContainer" aria-labelledby="cartNameHeader" data-reveal>
  <div class="shopping-cart-modal">
    <button type="button" class="close" aria-label="Close modal" data-close>
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="modal-header" style="border-bottom: none;padding-top: 20px; padding-bottom: 0;">
      <p class="modal-title" id="cartNameHeader" style="font-size: 18px; font-weight: 300;">Cart Name</p>
    </div>
    <div class="modal-body">
      <input class="cart-name-modal col-md-12" #editCartShopCartName type="text" style="padding-left: 0;">
      <button type="button" class="button add-cart-btn button-red col-md-12 add-cart-btn-new" (click)="addNewCartWithName(editCartShopCartName.value)" (click)="d('Cross click')">Add
        cart</button>
    </div>
  </div>
</div> -->
<ng-template #changeCartNameContainer let-c="close" let-d="dismiss">
    <div class="shopping-cart-modal">
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
        <div class="modal-header">
            <h6 class="pop-up-title">Cart Name</h6>
        </div>
        <div class="modal-body align-center">
            <input class="cart-name-modal pop-up-black-text col-md-12" autofocus #editCartShopCartName type="text" (keyup.enter)="addNewCartWithName(editCartShopCartName.value); d('Cross click')">
            <button type="button" class="button button-red button-large col-md-12" (click)="addNewCartWithName(editCartShopCartName.value)" (click)="d('Cross click')">Add cart</button>
        </div>
    </div>
</ng-template>